import { makeRequestCreator } from './common.js'
import store from '@/store'

const RecentAPI = {
  /**
 * 최근 본 상품 목록을 요청한다.
 * @param {Function} successCallback - 호출 성공시 호출할 콜백
 * @param {Function} errorCallback - 호출 실패시 호출할 콜백
 */
  getRecentProductList: (
    successCallback = () => {},
    errorCallback = () => {}
  ) => {
    // 로그인 체크
    makeRequestCreator(
      'getRecentProductList',
      {
        method: 'get',
        url: `/v2/recentlyview/list/${store.getters['main/shopSeq']}`
      },
      successCallback,
      errorCallback
    )
  },
  /**
 * 최근 본 상품을 추가 요청한다.
 * @param {Array} productIds - 제품 id 배열
 * @param {Function} successCallback - 호출 성공시 호출할 콜백
 * @param {Function} errorCallback - 호출 실패시 호출할 콜백
 */
  addRecentProducts: (
    productIds,
    successCallback = () => {},
    errorCallback = () => {}
  ) => {
    // 로그인 체크
    makeRequestCreator(
      'addRecentProducts',
      {
        method: 'post',
        url: `/v2/recentlyview/save/${store.getters['main/shopSeq']}`,
        data: {
          productIds
        }
      },
      successCallback,
      errorCallback
    )
  },
  /**
 * 최근 본 상품 중 특정 상품을 삭제 요청한다.
 * @param {Number} productId - 제품 id
 * @param {Function} successCallback - 호출 성공시 호출할 콜백
 * @param {Function} errorCallback - 호출 실패시 호출할 콜백
 */
  removeRecentProduct: (
    productId,
    successCallback = () => {},
    errorCallback = () => {}
  ) => {
    //
    makeRequestCreator(
      'removeRecentProduct',
      {
        method: 'post',
        url: `/v2/recentlyview/delete/${store.getters['main/shopSeq']}`,
        data: {
          productId
        }
      },
      successCallback,
      errorCallback
    )
  }
}

export default RecentAPI
